import { StrictMode, Suspense } from 'react';
import * as ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { DrycutApolloProvider } from 'drycut-apollo';
import router from './router';
import 'tailwindcss/tailwind.css';
import './styles.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <StrictMode>
    <DrycutApolloProvider>
      <Suspense fallback={<div>Loading...</div>}>
        <RouterProvider router={router} />
      </Suspense>
    </DrycutApolloProvider>
  </StrictMode>,
);
